import styled from 'styled-components';

export const Container = styled.section`
  h2 {
    font-size: 31px;
    line-height: 1.1;
    color: #484f52;
    font-weight: 400;
    align-self: start;
    margin: 1rem 0 1rem 4vw;
  }
  .slick-list {
    padding-left: 4vw;
  }
  .slick-slide {
    margin: 0 5px;
  }
  .slick-track {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
`;
